import { Space, Typography, Input, Steps, message, Flex, Modal, InputNumber, Form, notification } from "antd";
import { StyledCard } from "src/styled_components/StyledCard";
import "./BayesianOptimization.scss";
import { useEffect, useRef, useState } from "react";
import GetData from "./GetData/GetData";
import Objective from "./Objective/Objective";
import Constraints from "./Constraints/Constraints";
import { StyledButton } from "src/styled_components/StyledButton";
import { useDispatch, useSelector, } from "react-redux";
import { getPredictExperimentCleanup, getPredictExperimentRequest, getWorkOrderBayesianDataCleanup } from "src/store/actions/extrapolation";
import useTranslate, { LanguageUnion } from "src/utils/useTranslate";
import { CloseOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { CustomPrompt } from "src/utils/CustomPrompts";
import { AsyncStates } from "src/constants";
import { StoreState } from "src/store/configureStore";
import { Unsubscribe, doc, onSnapshot } from "firebase/firestore";
import { firestoreDb } from "src/utils/firebase";
import { messages } from "src/utils/hooks/useMessage";


const { Text } = Typography;

const steps = (t:any,isAllObjectivesSelected:boolean,setIsAllObjectivesSelected:React.Dispatch<React.SetStateAction<boolean>>,setPredictExperiment: React.Dispatch<React.SetStateAction<{ kappaValue: number, suggestedExperiments: number }>>, propertiesDataList: any, setPropertiesDataList: React.Dispatch<React.SetStateAction<any>>, FormData: any, setUnsavedChanges: React.Dispatch<React.SetStateAction<boolean>>, setOpen: React.Dispatch<React.SetStateAction<boolean>>, workOrder: string[], setSelectedWorkOrder: React.Dispatch<React.SetStateAction<string[]>>, objectiveRows: ObjectiveItem[], setObjectiveRows: React.Dispatch<React.SetStateAction<ObjectiveItem[]>>, constraintRows: {
    ingredients: any[];
    processing: any[];
    //characterization: any[];
}, setConstraintRows: React.Dispatch<React.SetStateAction<{
    ingredients: any[];
    processing: any[];
    //characterization: any[];
}>>, trialInputsData: Record<DataTypeKey, string[]>, setTrialInputsData: React.Dispatch<React.SetStateAction<Record<DataTypeKey, string[]>>>, userIgnoredData: Record<DataTypeKey, string[]>, setUserIgnoredData: React.Dispatch<React.SetStateAction<Record<DataTypeKey, string[]>>>, initialConstraintsRef: React.MutableRefObject<{ ingredients: any[]; processing: any[]; characterization: any[]; } | null>) => [
        { title: t("extrapolation.getData"), content: <GetData initialConstraintsRef={initialConstraintsRef} setPredictExperiment={setPredictExperiment} setRows={setObjectiveRows} setConstraintRows={setConstraintRows} FormData={FormData} setUnsavedChanges={setUnsavedChanges} userIgnoredData={userIgnoredData} setUserIgnoredData={setUserIgnoredData} trialInputsData={trialInputsData} setTrialInputsData={setTrialInputsData} workOrder={workOrder} setSelectedWorkOrder={setSelectedWorkOrder} /> },
        { title: t("common.objective"), content: <Objective isAllObjectivesSelected={isAllObjectivesSelected} setIsAllObjectivesSelected={setIsAllObjectivesSelected} trialInputsData={trialInputsData} propertiesDataList={propertiesDataList} setPropertiesDataList={setPropertiesDataList} setUnsavedChanges={setUnsavedChanges} setOpen={setOpen} rows={objectiveRows} setRows={setObjectiveRows} userIgnoredData={userIgnoredData} /> },
        { title: t("common.constraints"), content: <Constraints trialInputsData={trialInputsData} userIgnoredData={userIgnoredData} setUnsavedChanges={setUnsavedChanges} initialConstraintsRef={initialConstraintsRef} rows={constraintRows} setRows={setConstraintRows} /> },
    ];

type ObjectiveItem = { id: number;[key: string]: any };
type DataTypeKey = 'ingredients' | 'processing' | 'properties' | 'formulations';

interface BayesianOptimizationProps {
    trialInputsData: Record<DataTypeKey, string[]>
    setTrialInputsData: React.Dispatch<React.SetStateAction<Record<DataTypeKey, string[]>>>
    userIgnoredData: Record<DataTypeKey, string[]>
    setUserIgnoredData: React.Dispatch<React.SetStateAction<Record<DataTypeKey, string[]>>>
}

const objectiveInitialState: ObjectiveItem[] = [{ id: Date.now(), error: false, errorType: "", errMsg: "" }]

const BayesianOptimization: React.FC<BayesianOptimizationProps> = (props: BayesianOptimizationProps) => {
    const { trialInputsData, setTrialInputsData, userIgnoredData, setUserIgnoredData } = props;
    const dispatch = useDispatch();
    const [t] = useTranslate()
    const [FormData] = Form.useForm();
    const [page, setPage] = useState<number>(0);
    const [open, setOpen] = useState<boolean>(false)
    const [title, setTitle] = useState<string>('')
    const [workOrder, setSelectedWorkOrder] = useState<string[]>([]);
    const [objectiveRows, setObjectiveRows] = useState<ObjectiveItem[]>(objectiveInitialState);
    const [noteOne, setNoteOne] = useState<boolean>(true);
    const [noteTwo, setNoteTwo] = useState<boolean>(true)
    const [unsavedChanges, setUnsavedChanges] = useState<boolean>(false);
    const [isAllObjectivesSelected, setIsAllObjectivesSelected] = useState<boolean>(false);
    const [propertiesDataList, setPropertiesDataList] = useState<any>([]);
    const [constraintRows, setConstraintRows] = useState<{
        ingredients: any[];
        processing: any[];
        //characterization: any[];
    }>({
        ingredients: [],
        processing: [],
        //characterization: []
    })
    const initialConstraintsRef = useRef<{
        ingredients: any[];
        processing: any[];
        characterization: any[];
    } | null>(null);
    const [predictExperiment, setPredictExperiment] = useState<{ kappaValue: number, suggestedExperiments: number }>({ kappaValue: 2.5, suggestedExperiments: 10 })

    const { getWorkOrderBayesianDataStatus, predictExprimentData, predictExprimentStatus } = useSelector((state: StoreState) => state.extrapolation);
    const { current, selectAllProjects } = useSelector(
        (state: StoreState) => state.projects,
    )
    const ln: LanguageUnion = useSelector(
        (state: StoreState) => state.language.current
    );
    const currentSteps = steps(t,isAllObjectivesSelected,setIsAllObjectivesSelected,setPredictExperiment, propertiesDataList, setPropertiesDataList, FormData, setUnsavedChanges, setOpen, workOrder, setSelectedWorkOrder, objectiveRows, setObjectiveRows, constraintRows, setConstraintRows, trialInputsData, setTrialInputsData, userIgnoredData, setUserIgnoredData, initialConstraintsRef);

    const checkPredictionTitle = (title: string): boolean => {
        return title?.trim()?.length > 0;
    }

    useEffect(() => {
        dispatch(getWorkOrderBayesianDataCleanup())
        setPage(0)
        setSelectedWorkOrder([])
        setObjectiveRows(objectiveInitialState)
        setConstraintRows({
            ingredients: [],
            processing: [],
            //characterization: []
        })
        setUserIgnoredData({
            ingredients: [],
            processing: [],
            properties: [],
            formulations: []
        })
        setTrialInputsData({
            ingredients: [],
            processing: [],
            properties: [],
            formulations: []
        })
        setPredictExperiment({ kappaValue: 2.5, suggestedExperiments: 10 })
        FormData.resetFields()

    }, [current, selectAllProjects, dispatch, FormData, setUserIgnoredData, setTrialInputsData])




    const next = () => {
        if (page === 0) {
            if (!checkPredictionTitle(title)) {
                message.error(t("extrapolation.bayesianOptimization.predictionTitleRequired"));
                return;
            }
            if (workOrder?.length === 0) {
                message.error(t("extrapolation.bayesianOptimization.workOrderRequired"));
                return;
            }
            if (getWorkOrderBayesianDataStatus !== AsyncStates.SUCCESS) {
                message.error(t("extrapolation.bayesianOptimization.workOrderApiHit"));
                return;
            }
            setPage(page + 1);
        }
        else if (page === 1) {
            if (Object.keys(propertiesDataList)?.length === 0) {
                setPage(page + 1)
                return;
            }
            else {
                // check if
                if (objectiveRows?.length === 0) {
                    message.error(t("extrapolation.bayesianOptimization.selectOneObjective"));
                    return;
                }
                let bool = false
                for (const [index, item] of objectiveRows.entries()) {
                    if (!item?.objective) {
                        setObjectiveRows(prev => {
                            const newRows = [...prev];
                            newRows[index].error = true;
                            newRows[index].errMsg = t("extrapolation.bayesianOptimization.objectiveRequired");
                            newRows[index].errorType = "objective";
                            return newRows;
                        })
                        bool = true
                    }
                    else if (!item?.optimisationType) {
                        setObjectiveRows(prev => {
                            const newRows = [...prev];
                            newRows[index].error = true;
                            newRows[index].errMsg = t("extrapolation.bayesianOptimization.optimisationTypeRequired");
                            newRows[index].errorType = "optimisationType";
                            return newRows;
                        })
                        bool = true
                    }
                    else if (item?.optimisationType?.toLowerCase() === "range" && (item?.minValue === null || item?.minValue === undefined)) {
                        setObjectiveRows(prev => {
                            const newRows = [...prev];
                            newRows[index].error = true;
                            newRows[index].errMsg = t("extrapolation.bayesianOptimization.minimumValueRequired");
                            newRows[index].errorType = "minValue";
                            return newRows;
                        })
                        bool = true
                    }
                    else if (item?.optimisationType?.toLowerCase() === "range" && (item?.maxValue === null || item?.maxValue === undefined)) {
                        setObjectiveRows(prev => {
                            const newRows = [...prev];
                            newRows[index].error = true;
                            newRows[index].errMsg = t("extrapolation.bayesianOptimization.maximumValueRequired");
                            newRows[index].errorType = "maxValue";
                            return newRows;
                        })
                        bool = true
                    }
                    else if ((item?.optimisationType?.toLowerCase() === "maximize" || item?.optimisationType?.toLowerCase() === "minimize") && !item?.priority) {
                        setObjectiveRows(prev => {
                            const newRows = [...prev];
                            newRows[index].error = true;
                            newRows[index].errMsg = t("extrapolation.bayesianOptimization.priorityRequired");
                            newRows[index].errorType = "priority";
                            return newRows;
                        })
                        bool = true
                    } else if (item?.error) {
                        bool = true
                    }
                }
                if (bool) {
                    return;
                }
                setPage(page + 1)
            }

        }
        else {
            const { ingredients, processing } = constraintRows;
            let bool = false
            for (const [index, item] of ingredients.entries()) {
                if ((item?.minValue === null || item?.minValue === undefined) && !item?.selectedOption) {
                    setConstraintRows(prev => {
                        const newRows = { ...prev };
                        newRows.ingredients = [...prev.ingredients];
                        newRows.ingredients[index] = {
                            ...newRows.ingredients[index],
                            error: true,
                            errMsg: t("extrapolation.bayesianOptimization.minimumValueRequired"),
                            errorType: "minValue"
                        };
                        return newRows;
                    })
                    bool = true
                }
                else if ((item?.maxValue === null || item?.maxValue === undefined) && !item?.selectedOption) {
                    setConstraintRows(prev => {
                        const newRows = { ...prev };
                        newRows.ingredients = [...prev.ingredients];
                        newRows.ingredients[index] = {
                            ...newRows.ingredients[index],
                            error: true,
                            errMsg: t("extrapolation.bayesianOptimization.maximumValueRequired"),
                            errorType: "maxValue"
                        };
                        return newRows;
                    })
                    bool = true
                }
                else if (item?.selectedOption && item?.selectedOption?.length === 0) {
                    setConstraintRows(prev => {
                        const newRows = { ...prev };
                        newRows.ingredients = [...prev.ingredients];
                        newRows.ingredients[index] = {
                            ...newRows.ingredients[index],
                            error: true,
                            errMsg: t("extrapolation.bayesianOptimization.selectOneOption"),
                            errorType: "selectedOption"
                        };
                        return newRows;
                    })
                    bool = true
                }
                else if (item?.error) {
                    bool = true
                }

            }
            for (const [index, item] of processing.entries()) {
                if ((item?.minValue === null || item?.minValue === undefined) && !item?.selectedOption) {
                    setConstraintRows(prev => {
                        const newRows = { ...prev };
                        newRows.processing = [...prev.processing];
                        newRows.processing[index] = {
                            ...newRows.processing[index],
                            error: true,
                            errMsg: t("extrapolation.bayesianOptimization.minimumValueRequired"),
                            errorType: "minValue"
                        };
                        return newRows;
                    })
                    bool = true
                }
                else if ((item?.maxValue === null || item?.maxValue === undefined) && !item?.selectedOption) {
                    setConstraintRows(prev => {
                        const newRows = { ...prev };
                        newRows.processing = [...prev.processing];
                        newRows.processing[index] = {
                            ...newRows.processing[index],
                            error: true,
                            errMsg: t("extrapolation.bayesianOptimization.maximumValueRequired"),
                            errorType: "maxValue"
                        };
                        return newRows;
                    })
                    bool = true
                }
                else if (item?.selectedOption && item?.selectedOption?.length === 0) {
                    setConstraintRows(prev => {
                        const newRows = { ...prev };
                        newRows.processing = [...prev.processing];
                        newRows.processing[index] = {
                            ...newRows.processing[index],
                            error: true,
                            errMsg: t("extrapolation.bayesianOptimization.selectOneOption"),
                            errorType: "selectedOption"
                        };
                        return newRows;
                    })
                    bool = true
                }
                else if (item?.error) {
                    bool = true
                }
            }
            // for (const [index, item] of characterization.entries()) {
            //     if ((item?.minValue === null || item?.minValue === undefined) && !item?.selectedOption) {
            //         setConstraintRows(prev => {
            //             const newRows = { ...prev };
            //             newRows.characterization = [...prev.characterization];
            //             newRows.characterization[index] = {
            //                 ...newRows.characterization[index],
            //                 error: true,
            //                 errMsg: t("extrapolation.bayesianOptimization.minimumValueRequired"),
            //                 errorType: "minValue"
            //             };
            //             return newRows;
            //         })
            //         bool = true
            //     }
            //     else if ((item?.maxValue === null || item?.maxValue === undefined) && !item?.selectedOption) {
            //         setConstraintRows(prev => {
            //             const newRows = { ...prev };
            //             newRows.characterization = [...prev.characterization];
            //             newRows.characterization[index] = {
            //                 ...newRows.characterization[index],
            //                 error: true,
            //                 errMsg: t("extrapolation.bayesianOptimization.maximumValueRequired"),
            //                 errorType: "maxValue"
            //             };
            //             return newRows;
            //         })
            //         bool = true
            //     }
            //     if (item?.selectedOption && item?.selectedOption?.length === 0) {
            //         setConstraintRows(prev => {
            //             const newRows = { ...prev };
            //             newRows.characterization = [...prev.characterization];
            //             newRows.characterization[index] = {
            //                 ...newRows.characterization[index],
            //                 error: true,
            //                 errMsg: t("extrapolation.bayesianOptimization.selectOneOption"),
            //                 errorType: "selectedOption"
            //             };
            //             return newRows;
            //         })
            //         bool = true
            //     }
            //     else if (item?.error) {
            //         bool = true
            //     }
            // }
            if (bool) {
                return;
            }
            setOpen(true)
        }

    };

    const prev = () => {
        setPage(page - 1);
    };

    useEffect(() => {
        return () => {
            setUserIgnoredData({
                ingredients: [],
                processing: [],
                properties: [],
                formulations: []
            })
            setTrialInputsData({
                ingredients: [],
                processing: [],
                properties: [],
                formulations: []
            })
            dispatch(getWorkOrderBayesianDataCleanup())
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch])

    const handleReset = () => {
        if (page === 1) {
            setObjectiveRows(objectiveInitialState)
            setIsAllObjectivesSelected(false)
        }
        else if (page === 2) {
            setConstraintRows(initialConstraintsRef?.current ?? {
                ingredients: [],
                processing: [],
                characterization: []
            })
        }

    }

    const handleCancel = () => {
        setNoteOne(true);
        setNoteTwo(true);
        setOpen(false);
    };

    const handleOk = () => {
        if (page === 1) {
            setOpen(false);
            return;
        }
        type PayloadType = {
            priority_list: Record<string, any>;
            objectives: Record<string, any>;
            title: string;
            kappa: number;
            num_points: number;
            feature_bounds: Record<string, { min: number; max: number }>;
            ignore_inputs: string[];
            ignore_trials: string[];
            work_order_id: string;
        };

        let payload: PayloadType = {
            priority_list: {},
            objectives: {},
            title,
            kappa: predictExperiment.kappaValue,
            num_points: predictExperiment.suggestedExperiments,
            feature_bounds: {},
            ignore_inputs: [],
            ignore_trials: [],
            work_order_id: workOrder?.[0] ?? ''
        };

        objectiveRows?.forEach((item) => {
            payload.priority_list = { ...payload.priority_list, [item.key]: item?.priority };
            payload.objectives = {
                ...payload.objectives,
                [item.key]:
                    item?.optimisationType?.toLowerCase() === "range"
                        ? { min: item?.minValue, max: item?.maxValue }
                        : item?.optimisationType?.toLowerCase()
            };
        });
        constraintRows.ingredients?.forEach((item) => {
            payload.feature_bounds = { ...payload.feature_bounds, [item.identifier]: item?.selectedOption?.length > 0 ? item?.selectedOption : { min: item.minValue, max: item.maxValue } };
        });
        // constraintRows.characterization?.forEach((item) => {
        //     payload.feature_bounds = { ...payload.feature_bounds, [item.identifier]: item?.selectedOption?.length > 0 ? item?.selectedOption : { min: item.minValue, max: item.maxValue } };
        // });
        constraintRows.processing?.forEach((item) => {
            payload.feature_bounds = { ...payload.feature_bounds, [item.identifier]: item?.selectedOption?.length > 0 ? item?.selectedOption : { min: item.minValue, max: item.maxValue } };
        });
        userIgnoredData?.ingredients.forEach((item: string) => {
            payload.ignore_inputs.push(item);
        });
        userIgnoredData?.processing.forEach((item: string) => {
            payload.ignore_inputs.push(item);
        });
        userIgnoredData?.properties.forEach((item: string) => {
            payload.ignore_inputs.push(item);
        });
        userIgnoredData?.formulations.forEach((item: string) => {
            payload.ignore_trials.push(item);
        });
        dispatch(getPredictExperimentRequest({ payload }))

        setOpen(false);
        setNoteOne(true);
        setNoteTwo(true);
        setUnsavedChanges(false);
    };

    useEffect(() => {
        let unsub: Unsubscribe
        const listenToDataSaveTaskStatus = async () => {
          const taskDocRef = doc(firestoreDb, `${predictExprimentData?.firestore_collection}/${predictExprimentData?.prediction_id}`)
          unsub = onSnapshot(taskDocRef, (doc) => {
            const taskDoc = doc.data()
           // console.log(taskDoc, 'taskDoc1',predictExprimentData)
            if (taskDoc && taskDoc?.status === "finished") {
                //console.log(taskDoc, 'taskDoc2')
                notification.success({
                    message: messages[ln].beyesianPredCompleted,
                    duration: 5,
                })
                dispatch(getPredictExperimentCleanup())
                unsub()
            }
           
          })
        }
        //console.log(predictExprimentStatus, 'predictExprimentStatus')
        if(predictExprimentData && predictExprimentData?.prediction_id){
                listenToDataSaveTaskStatus()
        }

        return () => {
            unsub && unsub()
        }
      }, [dispatch, ln, predictExprimentData, predictExprimentStatus])

    return (<Space direction="vertical" className="bayesian-container" size="large">
        <CustomPrompt
            isEditing={unsavedChanges}
            message={`${t("aiEngine.inputsFrom")} ${t(
                "aiEngine.extrapolation",
            )} ${t("aiEngine.predictionNotPredicted")} ${t(
                "common.unsavedChangesLost",
            )}`}
        />
        <Space direction="horizontal" size="middle" style={{ width: '100%' }}>

            <Text><Text style={{ color: "red", marginRight: 4 }}>*</Text>{t("extrapolation.bayesianOptimization.predictionTitle")}</Text>
            <Input placeholder={t("extrapolation.enterTitle")} value={title} className="prediction-input" onChange={(e) => setTitle(e.target.value)} />
        </Space>
        <StyledCard style={{ width: "100%" }}>
            <Steps size="small" current={page} items={currentSteps?.map((item) => ({ key: item.title, title: item.title }))} style={{ width: '50%' }} />
            <div >{currentSteps[page]?.content}</div>
        </StyledCard>
        <Modal
            width={600}
            title={t("extarpolation.objective.configuration")}
            okText={`${page === 1 ? t("common.confirm") : t("extrapolation.bayesianOptimization.predictExperiment")}`}
            closable={true}
            open={open}
            onOk={handleOk}
            cancelText={t("common.cancel")}
            onCancel={handleCancel}
        >
            <hr style={{ margin: "10px 0px 0px 0px" }} />
            <Space direction="vertical" size={'middle'} style={{ width: '100%' }} >
                <Text>{t("extrapolation.constraints.inputConfig")}</Text>

                <Space direction="vertical" size={4} style={{ width: '100%' }}>
                    <Text strong>{t("extrapolation.constraints.kaapaValue")}</Text>
                    <InputNumber
                        onChange={(val) => setPredictExperiment({ ...predictExperiment, kappaValue: val ?? 0 })}
                        value={predictExperiment?.kappaValue}
                        style={{ width: '40%' }}
                    />
                </Space>
            </Space>
            {noteOne && <div
                style={{
                    marginTop: 12,
                    backgroundColor: '#e6f4ff',
                    borderRadius: 6,
                    padding: 12,
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: 26,
                }}
            >
                <Space direction="vertical" size={"middle"}>
                    <Space direction="horizontal" size="small">
                        <InfoCircleOutlined style={{ marginRight: 10 }} />
                        <Text style={{ whiteSpace: 'normal', fontSize: 12 }}>
                            {t("extrapolation.constraints.kaapaValueNote")}
                        </Text>
                        <CloseOutlined onClick={() => setNoteOne(false)} style={{ position: 'relative', top: -15, cursor: "pointer" }} />
                    </Space>
                    <Space direction="vertical" style={{ paddingLeft: 40, fontSize: 12 }} size={0}>
                        <Text>{t("extrapolation.constarints.note")}</Text>
                        <Text>• {t("extrapolation.constaints.noteSentenceOne")}</Text>
                        <Text>• {t("extrapolation.constaints.noteSentenceTwo")}</Text>
                        <Text>• {t("extrapolation.constaints.noteSentenceThree")}</Text>

                    </Space>
                </Space>
            </div>}
            <Space direction="vertical" size={4} style={{ width: '100%', marginTop: !noteOne ? 14 : 0 }}>
                <Text strong>{t("extrapolation.constraints.suggestedExperiments")}</Text>
                <InputNumber onChange={(val) => setPredictExperiment({ ...predictExperiment, suggestedExperiments: val ?? 0 })} value={predictExperiment?.suggestedExperiments} style={{ width: '40%' }} />
            </Space>
            {noteTwo && <div
                style={{
                    marginTop: 12,
                    backgroundColor: '#e6f4ff',
                    borderRadius: 6,
                    padding: 12,
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: 26,
                }}
            >
                <Space direction="horizontal" size="small">
                    <InfoCircleOutlined style={{ marginRight: 10 }} />
                    <Text style={{ whiteSpace: 'normal', fontSize: 12 }}>
                        {t("extrapolation.contsraints.suggestedExpNote")}
                    </Text>
                    <CloseOutlined onClick={() => setNoteTwo(false)} style={{ position: 'relative', top: -15, cursor: "pointer" }} />
                </Space>
            </div>}
        </Modal>
        <Flex justify={'space-between'} align={"center"}>
            <Space style={{ marginRight: "8px" }}>
                {page > 0 && <StyledButton className="back-button" onClick={() => prev()}>{t("extrapolation.bayesianOptimization.back")}</StyledButton>}
                {page > 0 && <StyledButton className="reset-button" onClick={handleReset}>{t("extrapolation.bayesianOptimization.reset")}</StyledButton>}</Space>
            <Space><StyledButton className="common-button" type="primary" onClick={() => next()}>{page === 0 || page === 1 ? t("extrapolation.bayesianOptimization.continue") : t("extrapolation.bayesianOptimization.predictExperiment")}</StyledButton></Space>
        </Flex>
    </Space>)
};


export default BayesianOptimization;